
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { LngLat, LngLatBounds } from 'mapbox-gl';
import { MglGeojsonLayer, MglMap } from 'vue-mapbox';
import MapboxConfig from '@/config/MapboxConfig';

@Component({
  name: 'StatisticHeatmap',
  components: {
    MglMap,
    MglGeojsonLayer
  }
})
export default class StatisticHeatmap extends Vue {
  @Prop()
  private routeGeometries: string[]

  @Prop({ default: 20 })
  private fitPadding: number

  @Prop({ default: true })
  private interactive: boolean

  @Prop()
  private fullscreen: boolean;

  private map = null

  @Watch('fullscreen')
  private onFullscreenChange() {
    if (this.map && this.coordinatesCollection.length > 0) {
      this.map.actions.fitBounds(this.bounds, { padding: this.fitPadding, duration: 0 });
    }
  }

  get mapboxAccessToken() {
    return MapboxConfig.accessToken;
  }

  get coordinatesCollection(): number[][][] {
    return this.routeGeometries.map(routeGeometry => routeGeometry
      .replace('LINESTRING', '')
      .replace('( ', '')
      .replace(' )', '')
      .split(',')
      .map((coordinate) => {
        const splitted = coordinate.split(' ');
        return [+splitted[0], +splitted[1]];
    }));
  }

  get source() {
    return {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: this.coordinatesCollection.map(coordinates => ({
          type: 'Feature',
          geometry: {
            type: 'LineString',
            coordinates
          }
        }))
      }
    }
  }

  get layer() {
    let opacity;

    if (this.routeGeometries.length <= 5) {
      opacity = '1.0';
    } else if (this.routeGeometries.length <= 10) {
      opacity = '0.8';
    } else {
      opacity = '0.2';
    }

    return {
      type: 'line',
      paint: {
        "line-color": `rgba(255,220,0,${opacity})`,
        "line-width": 5
      }
    }
  }

  get bounds() {
    const bounds = new LngLatBounds();
    this.coordinatesCollection.forEach(coordinates => {
      coordinates.forEach(coordinate => {
        bounds.extend(coordinate);
      })
    })
    return bounds;
  }

  private onMapLoad({ component }) {
    this.map = component
    if (this.coordinatesCollection.length > 0) {
      component.actions.fitBounds(this.bounds, { padding: this.fitPadding, duration: 0 });
    }
  }
}
